import { useQuery } from '@tanstack/react-query';
import { notification } from 'antd';
import { AxiosResponse } from 'axios';

import { EventSchema } from '@/features/irm/entities/events';
import { apiV1 } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

export type EventsResponse = {
  events: EventSchema[];
  totalItems: number;
  totalPages: number;
};

export type EventFilters = {
  search?: string;
  sorter?: string;
  order?: string;
  page?: number;
  size?: number;
  impact_ids?: string;
  event_type_ids?: string;
  origin_type?: string;
  user_names?: string;
  participant_ids?: string;
  is_created_by_admin?: boolean;
};


export const getEvents = (
  filters: EventFilters,
): Promise<AxiosResponse<EventsResponse>> => {
  const params: EventFilters = {
    sorter: filters.sorter,
    order: filters.order,
    page: filters.page,
    size: filters.size,
  };

  // Adiciona 'search' apenas se estiver definido e não vazio
  if (filters.search && filters.search.trim() !== '') {
    params.search = filters.search;
  }

  // Adiciona filtros de impacto
  if (filters.impact_ids) {
    params.impact_ids = filters.impact_ids;
  }

  // Adiciona filtros de tipo de evento
  if (filters.event_type_ids) {
    params.event_type_ids = filters.event_type_ids;
  }

  // Adiciona filtro de origem
  if (filters.origin_type) {
    params.origin_type = filters.origin_type;
  }

  // Adiciona filtro de nomes de usuários
  if (filters.user_names) {
    params.user_names = filters.user_names;
  }

  if (filters.participant_ids) {
    params.participant_ids = filters.participant_ids;
  }

  // Adiciona filtro de admin
  if (filters.is_created_by_admin) {
    params.is_created_by_admin = filters.is_created_by_admin;
  }

  return apiV1.get(`/v1/irm/event`, { params });
};

type QueryFnType = typeof getEvents;

type UseEventOptions = {
  companyId: string;
  filters?: EventFilters;
  config?: QueryConfig<QueryFnType>;
};

export const useEvents = ({ companyId, config, filters }: UseEventOptions) => {

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    onError: () => {
      notification.error({ message: `Não foi possível buscar os eventos relevantes.` });
    },
    ...config,
    queryKey: [`events`, companyId, filters],
    queryFn: () => getEvents({...filters}),
    enabled: !!companyId && !!filters,
  });
};
